import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestNews() {
  const latestArticles = getLatestArticles(8);
  const firstArticle = latestArticles[0];
  const gridArticles = latestArticles.slice(1, 7);
  const compactArticles = latestArticles.slice(7, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <div className="w-1 h-5 rounded-full bg-primary-500"></div>
            <h2 className="font-heading text-lg font-bold text-foreground-900">最新爆料</h2>
          </div>
          <Link to="/category/film-tv" className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer">
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <ArticleCard
              variant="horizontal"
              slug={firstArticle.slug}
              title={firstArticle.title}
              excerpt={firstArticle.excerpt}
              image={firstArticle.image}
              categoryName={firstArticle.categoryName}
              categorySlug={firstArticle.categorySlug}
              publishDate={firstArticle.publishDate}
              views={firstArticle.views}
            />
          </div>
          <div className="flex flex-col gap-4">
            {compactArticles.map((article) => (
              <ArticleCard
                key={article.id}
                variant="compact"
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                image={article.image}
                categoryName={article.categoryName}
                categorySlug={article.categorySlug}
                publishDate={article.publishDate}
                views={article.views}
              />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
          {gridArticles.map((article) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              image={article.image}
              categoryName={article.categoryName}
              categorySlug={article.categorySlug}
              publishDate={article.publishDate}
              views={article.views}
            />
          ))}
        </div>
      </div>
    </section>
  );
}